import CryptoJS from 'crypto-js';

export const generateHashByArray = (arr: Array<unknown>): string => {
  const jsonString = JSON.stringify(arr);

  return CryptoJS.SHA256(jsonString).toString();
};

export const splitArrByComma = (arr: string | null): string[] => arr?.split(',') || [];
